import * as React from 'react';

const EuiIconEmpty = ({ title, titleId, ...props }) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  />
);

export const icon = EuiIconEmpty;
